<template>
  <div>
    <v-autocomplete
      :value="template"
      :items="filterTemplates"
      :label="$i18n.t(label)"
      @change="changedTo"
      @click:clear="clear"
      :loading="temp_loading"
      :search-input.sync="filter"
      ref="select"
      autocomplete="nope"
      :no-filter="true"
      :dense="dense"
    >
      <template v-slot:selection="data">
        <div ripple dense class="height32" v-if="data && data.item">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title v-if="data && data.item">
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <!-- <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="taxClientDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Tax Slab") }}
          </v-btn>
        </div>
        <div class="actionBox" v-if="showInvoiceConfig">
          <v-btn small text color="info" @click="invoiceConfigDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Setup Tax Configuration") }}
          </v-btn>
        </div>
      </template> -->
    </v-autocomplete>
    <!-- <z-tax-create
      @select="selectTaxSlab"
      :showDialog="taxClientDialog"
    ></z-tax-create>
    <z-invoice-config-set
      v-if="showInvoiceConfig"
      @closeInvConfig="closeInvConfig"
      :showDialog="invoiceConfigDialog"
      :client_id="client_id"
    ></z-invoice-config-set> -->
  </div>
</template>

<script>
// import { doGet } from "@/store/common/module/apis";
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "TemplateSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Select File",
    },
    kind: {
      default: false,
    },
    forUpload: {
      default: false,
    },
    dense: {
      default: false,
    },
  },
})
export default class TemplateSelect extends (Vue, Themeable) {
  template = null;
  template_id = null;
  templates = [];
  filter = "";
  //   invoiceConfigDialog = false;
  temp_loading = false;

  clear() {
    this.filter = "";
    this.template = null;
    this.$emit("input", null);
    this.$emit("inputName", null);
  }

  get filterTemplates() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.templates;
    const fs = this.templates.filter(function (s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  //   closeInvConfig() {
  //     this.invoiceConfigDialog = false;
  //   }

  //   selectTaxSlab(newTax) {
  //     this.taxClientDialog = false;
  //     if (newTax != null) {
  //       this.tax_id = newTax._id;
  //       this.init();
  //     }
  //   }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) {
      this.template = newVal;
    }
    if (newVal && newVal.name) {
      this.$emit("input", newVal._id);
      this.$emit("inputName", newVal.name);
    }
    if (!newVal) {
      this.$emit("input", null);
      this.$emit("inputName", null);
    }
  }

  @Watch("value")
  async onValueChange(newVal) {
    this.template_id = newVal;
    this.init();
  }

  async init() {
    this.filter = "";
    const _key = this.kind + "_" + this.forUpload;
    this.temp_loading = true;
    await corpService.populateTemplates(_key);
    const templates = corpService.templates[_key];
    this.temp_loading = false;
    this.templates = templates;

    if (!this.value && this.templates && this.templates.length > 0) {
      this.template = this.templates[0];
      this.$emit("input", this.templates[0]._id);
      this.$emit("inputName", this.templates[0].name);
    }
  }

  async mounted() {
    await this.onValueChange(this.value);
  }

  selected(val) {
    if (
      val != null &&
      val._id != null &&
      this.template != null &&
      this.template._id != undefined
    ) {
      if (val._id === this.template._id) {
        return true;
      }
    }
    return false;
  }

  @Watch("kind", { immediate: true })
  async onKindChange() {
    await this.init();
  }

  @Watch("forUpload", { immediate: true })
  async onForUploadChange() {
    await this.init();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
